export default __webpack_public_path__ + "static/media/RightThinArrowBack.f710bf51.svg";